import React , { useState } from 'react'
import PropTypes from 'prop-types'
import { isNil, isNull } from 'lodash'
import moment from 'moment'
import { useDeepEffect } from '../../../utils/hooks'
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Button,
  Radio,
  TimePicker,
  Avatar
} from 'antd'
import { disabledBeforeCurrentDate } from '../../../utils/dateTime'
import g2gImage from '../../../assets/images/g2g.png'
import heroImage from '../../../assets/images/icon_hero_green2get.png'

const NotificationForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields } = form
  const [characterTitleCount, setcharacterTitleCount] = useState(0)
  const [characterMessageCount, setcharacterMessageCount] = useState(0)

  useDeepEffect(() => {
    if (!isNull(formData) && !isNil(formData)) {
      form.setFieldsValue({
        userReceiverTypeId: formData.userReceiverTypeId,
        title: formData.title,
        message: formData.message,
        schedulingDate: moment(formData.schedulingDate),
        schedulingTime: moment(formData.schedulingDate)
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const schedulingDateTime = values.schedulingDate
        const time = values.schedulingTime

        schedulingDateTime.set({
          hour: time.get('hour'),
          minute: time.get('minute'),
          second: '00',
          millisecond: '000'
        })

        const data = {
          userReceiverTypeId: values.userReceiverTypeId,
          title: values.title,
          message: values.message,
          schedulingDate: moment(schedulingDateTime),
          dataString: '',
          notificationActionId: values.userReceiverTypeId === 2 ? 2 : 1
        }

        await onOk(data)
        await form.resetFields()
      }
    })
  }

  return (
    <Modal
      width={1000}
      destroyOnClose={true}
      title={`Notification`}
      visible={visible}
      onCancel={onCancel}
      footer={null}>
      <Form name="formBrandActivity" onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Notification Target App">
          {getFieldDecorator(`userReceiverTypeId`, {
            initialValue: true,
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={2}>
                <Avatar
                  key={'g2gImage'}
                  shape="square"
                  src={g2gImage}
                  size={25}
                  style={{ marginRight: 5 }}
                />
                Green2Get
              </Radio>
              <Radio value={3}>
                <Avatar
                  key={'heroImage'}
                  shape="square"
                  src={heroImage}
                  size={35}
                  style={{ marginRight: 5 }}
                />
                Hero
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" gutter={[8, 8]}>
          <Col span={4}>
            <Form.Item label="Scheduling ">
              {getFieldDecorator(`schedulingDate`, {
                rules: [
                  {
                    required: true,
                    message: 'กรุณากรอก'
                  }
                ]
              })(<DatePicker disabledDate={disabledBeforeCurrentDate} />)}
            </Form.Item>
          </Col>
          <Col span={10}>
            <Form.Item>
              {getFieldDecorator(`schedulingTime`, {
                rules: [
                  {
                    required: true,
                    message: 'กรุณากรอก'
                  }
                ]
              })(
                <TimePicker
                  format={'HH:mm'}
                  minuteStep={30}
                  style={{ marginTop: 29 }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Notification Title">
          {getFieldDecorator(`title`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(e) => setcharacterTitleCount(e.target.value.length)} />)}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexDirection: 'column'
          }}>{characterTitleCount}</div>
        </Form.Item>
        <Form.Item label="Notification Text">
          {getFieldDecorator(`message`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(e) => setcharacterMessageCount(e.target.value.length)} />)}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexDirection: 'column'
          }}>{characterMessageCount}</div>
        </Form.Item>
        <Row type="flex" justify="end" gutter={8}>
          <Col>
            <Button onClick={() => onCancel()} key="cancel" type="danger">
              ยกเลิก
            </Button>
          </Col>
          <Col>
            <Button
              name="formBrandActivity"
              key="submit"
              type="primary"
              htmlType="submit">
              บันทึก
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

NotificationForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default NotificationForm



// WEBPACK FOOTER //
// ./src/pages/Notification/NotificationForm/index.js